module.exports = __webpack_public_path__ + "static/media/default-profile.5a021ab9.png";